module.exports = __webpack_public_path__ + "static/media/signing.b31257c9.gif";